import {useContext} from "react";
import AppContext from "../AppContext";
import {Button, Container} from "react-bootstrap";
import {TbClockExclamation} from "react-icons/tb";
import {Link} from "react-router-dom";
import './RenewSubscription.scss';
import {courseIcon} from "../Tools";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";

export default function RenewSubscription() {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const subs = app.user.subscriptions;

    let sub = false;
    switch (app.user.current_course) {
        case 1:
            sub = subs?.bth;
            break;
        case 2:
            sub = subs?.ath;
            break;
        case 3:
            sub = subs?.amth;
            break;
    }

    const course = () => {
        let c = false
        app.ui.courses.map(function(course, idx) {
            if(course.ID !== app.user.current_course)
                return null
            c = course
            return false
        })
        return <span className="fw-bold">{courseIcon(c.ID)} {c.name}</span>
    }

    return <Container fluid={true}>
        <div className="renew-subscription">
            <p><TbClockExclamation className="text-danger me-2" style={{fontSize: 64 }} /></p>
            <h3 className="fw-bolder mb-4 mt-4">{t('subExpired.title')}</h3>
            <p>
                <Trans i18nKey="subExpired.text" components={[course()]} />
            </p>
            <p className="pt-4">
                {sub && sub.pending > 0 ? <>
                    <p>
                        <h5 className="fw-bold">{t('subExpired.goodNews.title')}</h5>
                        <Trans i18nKey="subExpired.goodNews.text1" count={sub.pending} />
                        <br />
                        <Trans i18nKey="subExpired.goodNews.text2" components={[ <a href="/account#orders" /> ]} />
                    </p>
                        <Button href="/account#orders" variant="info" className="mt-4">
                            {t('button.activateNow')}
                        </Button>
                    </> :
                    <>
                <Link to={`/pricing/${app.user.current_course}`}>
                    <Button variant="primary" className="mt-4">
                        {t('button.viewPackages')}
                    </Button>
                </Link></>}
            </p>
        </div>
    </Container>
}